<template>
  <div class="storageInventoryHistory">
    <h2>历史库存统计</h2>
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker :clearable="false" v-model="searchParam.date" type="date" style="width: 130px;" />
      </el-form-item>
      <el-form-item label="仓储">
        <el-select v-model="searchParam.storage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="煤矿品名">
        <el-select v-model="searchParam.product" filterable style="width: 120px;" clearable>
          <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" border show-summary :summary-method="summary" :span-method="handleSpanMethod" style="height: calc(100vh - 310px);">
      <el-table-column prop="storage" label="仓储" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.type == 'sumStorage'" style="font-weight: bolder;">合计</el-text>
          <el-text v-else>{{ scope.row.storage }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="product" label="煤矿品名" show-overflow-tooltip />
      <el-table-column prop="quantity" label="库存量" show-overflow-tooltip align="right">
        <template #default="scope">
          <el-text v-if="scope.row.type == 'sumStorage'" style="font-weight: bolder;">{{ math.formatNumber(scope.row.quantity) }}</el-text>
          <el-text v-else>{{ math.formatNumber(scope.row.quantity) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="historyProductPrice" label="历史单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          <el-text>{{ math.formatNumber(scope.row.historyProductPrice) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="historyTransportPrice" label="历史运费单价" width="130" show-overflow-tooltip align="right">
        <template #default="scope">
          <el-text>{{ math.formatNumber(scope.row.historyTransportPrice) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="currentProductPrice" label="当前单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          <el-text>{{ math.formatNumber(scope.row.currentProductPrice) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="currentTransportPrice" label="当前运费单价" width="130" show-overflow-tooltip align="right">
        <template #default="scope">
          <el-text>{{ math.formatNumber(scope.row.currentTransportPrice) }}</el-text>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()

const data = reactive({
  list: [],
})

const show = reactive({
  storageList: [],
  productList: [],
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  show.productList = res.dictList
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.date = yesterday
  searchParam.storage = null
  searchParam.product = null
  searchParam.hasStorage = true
}
resetSearchParam()

const paramsList = []
const commitFindList = () => {
  if (!searchParam.date) {
    ElMessage.error('请选择日期')
    return
  }
  data.list = []
  const date = util.parseTime(searchParam.date, '{y}-{m}-{d}')
  for (const storageIndex in show.storageList) {
    const storage = show.storageList[storageIndex].value
    if (searchParam.storage == null || searchParam.storage == storage) {
      for (const productIndex in show.productList) {
        const product = show.productList[productIndex].value
        if (searchParam.product == null || searchParam.product == product) {
          const params = { date, storage, product }
          paramsList.push(params)
        }
      }
    }
    if (searchParam.hasStorage) {
      paramsList.push({ type: 'sumStorage', storage: storage })
    }
  }
  commitFindItem()
}

// 多行合并时按库存量加权求均价，没有单价的行不参与加权
const weightedPrice = (rows, field) => {
  let amount = 0
  let quantity = 0
  rows.forEach(row => {
    if (row[field] != null && row.quantity) {
      amount = math.plus(amount, math.multiply(row[field], row.quantity))
      quantity = math.plus(quantity, row.quantity)
    }
  })
  return quantity ? math.halfUp(math.divide(amount, quantity), 2) : null
}

const priceFields = ['historyProductPrice', 'historyTransportPrice', 'currentProductPrice', 'currentTransportPrice']

const commitFindItem = () => {
  if (paramsList.length <= 0) {
    if (!searchParam.hasStorage) {
      const rlist = []
      for (const rowIndex in data.list) {
        const oldRow = data.list[rowIndex]
        const sameProductRow = rlist.filter(newRow => newRow.product == oldRow.product)
        if (sameProductRow.length <= 0) {
          rlist.push({ ...oldRow, sourceRows: [oldRow] })
        } else {
          sameProductRow[0].quantity = math.plus(sameProductRow[0].quantity, oldRow.quantity)
          sameProductRow[0].sourceRows.push(oldRow)
        }
      }
      for (const rowIndex in rlist) {
        const row = rlist[rowIndex]
        row.storage = ''
        priceFields.forEach(field => {
          row[field] = weightedPrice(row.sourceRows, field)
        })
        delete row.sourceRows
      }
      data.list = rlist
    }
    return
  }
  const params = paramsList.shift()
  if (params.type == 'sumStorage') {
    const storageRows = data.list.filter(row => row.storage == params.storage)
    let sumQuantity = 0
    storageRows.forEach(row => {
      sumQuantity = math.plus(sumQuantity, row.quantity)
    })
    if (sumQuantity > 0) {
      const sumRow = {
        type: 'sumStorage',
        quantity: sumQuantity,
      }
      priceFields.forEach(field => {
        sumRow[field] = weightedPrice(storageRows, field)
      })
      data.list.push(sumRow)
    }
    commitFindItem()
  } else {
    api.get('/backend/inventory/info', { params: params }).then(res => {
      if (res.quantity) {
        const row = {
          storage: params.storage,
          product: params.product,
          quantity: res.quantity,
          historyProductPrice: res.historyProductPrice,
          historyTransportPrice: res.historyTransportPrice,
          currentProductPrice: res.currentProductPrice,
          currentTransportPrice: res.currentTransportPrice,
        }
        data.list.push(row)
      }
      commitFindItem()
    })
  }
}

const summary = () => {
  const rows = data.list.filter(row => row.type != 'sumStorage')
  let sumQuantity = 0
  rows.forEach(row => {
    sumQuantity = math.plus(sumQuantity, row.quantity)
  })
  return [
    '合计',
    '',
    math.formatNumber(sumQuantity),
    math.formatNumber(weightedPrice(rows, 'historyProductPrice')),
    math.formatNumber(weightedPrice(rows, 'historyTransportPrice')),
    math.formatNumber(weightedPrice(rows, 'currentProductPrice')),
    math.formatNumber(weightedPrice(rows, 'currentTransportPrice')),
  ]
}

const handleSpanMethod = ({ rowIndex, columnIndex }) => {
  const columnIndexs = [0] // 合并
  if (!columnIndexs.includes(columnIndex)) {
    return [1, 1]
  }
  const row = data.list[rowIndex]
  if (rowIndex > 0) {
    const lastrow = data.list[rowIndex - 1]
    if (columnIndex == 0 && row.storage == lastrow.storage) {
      return [0, 0]
    }
  }
  let span
  for (span = 1; rowIndex + span < data.list.length; span++) {
    const nextrow = data.list[rowIndex + span]
    if (columnIndex == 0 && row.storage != nextrow.storage) {
      break
    }
  }
  return [span, 1]
}
</script>

<style lang="less"></style>